import { authenticatedHeadersHash } from '../../../javascript/v2_authentication';

function apiParameters() {
  const authHeaders = authenticatedHeadersHash();
  const promoterAnalyticsApiUrl = `${window.V2_URL}/interact/api/promoter_analytics`;
  const prProfilesApiUrl = `${window.V2_SUPABASE_API_EXTERNAL_URL}/rest/v1/pr_profiles`;
  const teamsApiUrl = `${window.V2_SUPABASE_API_EXTERNAL_URL}/rest/v1/teams`;

  return {
    authHeaders,
    promoterAnalyticsApiUrl,
    prProfilesApiUrl,
    teamsApiUrl,
  };
}

async function acquireV2TeamId({ teamsApiUrl, authHeaders, v1ClientFirmId }) {
  const response = await fetch(`${teamsApiUrl}?select=id&migrate_id=eq.${v1ClientFirmId}`, {
    method: 'GET',
    headers: authHeaders,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  if (data.length > 0) {
    return data[0].id;
  }

  return null;
}

// Side-effectful API Functions
export function currentPitchingStatus() {
  return window.CURRENT_USER_JSON.attributes.pitching_status;
}

async function fetchProfileImagesDirectory({ prProfilesApiUrl, authHeaders, profileIds }) {
  const response = await fetch(
    `${prProfilesApiUrl}?select=profile_id,profile_image_url&profile_id=in.(${profileIds.join(',')})`,
    {
      method: 'GET',
      headers: authHeaders,
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  const result = {};
  data.forEach((current) => {
    result[current.profile_id] = current.profile_image_url;
  });
  return result;
}

async function fetchPromoterAnalytics({
 promoterAnalyticsApiUrl, authHeaders, teamId, period,
}) {
  const url = `${promoterAnalyticsApiUrl}?period=${period}&team_id=${teamId}&prs_only=true&order=desc`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: authHeaders,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data.data.promoters.map(
      ({ total_points: totalPoints, profile_id: profileId, profile_name: profileName }) => ({
        totalPoints,
        profileId,
        profileName,
      }),
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching promoter analytics:', error);
    throw error;
  }
}

export async function fetchComparativePromoterAnalytics({ previousPeriod, currentPeriod, v1ClientFirmId }) {
  const apiParams = apiParameters();
  const teamId = await acquireV2TeamId({ v1ClientFirmId, ...apiParams });
  const [rawPrevious, rawCurrent] = await Promise.all([
    fetchPromoterAnalytics({ teamId, period: previousPeriod, ...apiParams }),
    fetchPromoterAnalytics({ teamId, period: currentPeriod, ...apiParams }),
  ]);

  const profileIds = Array.from(new Set([...rawPrevious, ...rawCurrent].map((e) => e.profileId)));
  const profileImagesById = await fetchProfileImagesDirectory({
    profileIds,
    ...apiParams,
  });

  const fillProfileImages = (entries) => entries.map((entry) => ({
      ...entry,
      profileImageUrl: profileImagesById[entry.profileId] || null,
    }));

  const previous = fillProfileImages(rawPrevious);
  const current = fillProfileImages(rawCurrent);

  return { previous, current };
}
